import React, { useState } from 'react'

import {
  Box,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react'

import { DeviceType } from '@/graphql/generated/schemas'

import { getDeviceTypeMessage } from '../delete-device/utils/utils'
import { EditAlarmForm } from '../edit-alarm/components/EditAlarmForm'
import { EditCameraForm } from '../edit-camera/components/EditCameraForm'
import { EditDoorForm } from '../edit-door/components/EditDoorForm'
import { EditDeviceFieldsI } from '../types/types'
import { AssociateDevices } from './AssociateDevices'
import { DeviceModalHeader } from './DeviceModalHeader'
import { NoCameraAuthenticationAlert } from './NoCameraAuthenticationAlert'

interface EditDeviceModalIProps {
  onClose: () => void
  isOpen: boolean
  deviceData: EditDeviceFieldsI
}

export const EditDeviceModal = ({
  onClose,
  isOpen,
  deviceData,
}: EditDeviceModalIProps) => {
  const id = deviceData?.id
  const type = deviceData?.type
  const device = getDeviceTypeMessage(type)

  const [shouldRequireAuthentication, setShouldRequireAuthentication] =
    useState(true)
  const handleRequiresAuthenticationSwitch = (isChecked: boolean): void => {
    setShouldRequireAuthentication(isChecked)
  }
  const shouldShowNoCameraAuthenticationAlert =
    !shouldRequireAuthentication && type === DeviceType.Camera

  return (
    <Modal
      isCentered
      isOpen={isOpen}
      motionPreset='slideInBottom'
      onClose={onClose}
      scrollBehavior='inside'
      size='xl'
    >
      <ModalOverlay />
      <ModalContent bg='#fff' rounded='20px'>
        <ModalCloseButton color='#000' opacity={0.4} />
        <DeviceModalHeader title={`Edit ${device}`} />

        <Tabs
          bgColor='#FFFFFF'
          borderColor='transparent'
          fontWeight='500'
          isLazy
          px='10'
          rounded='20px'
        >
          <TabList>
            <Tab
              _selected={{
                color: 'components.tab.active',
                borderBottomColor: 'components.tab.active',
                opacity: 1,
              }}
              opacity={0.4}
            >
              <Box alignItems='center' display='inline-flex'>
                {`${device} Details`}
              </Box>
            </Tab>
            <Tab
              _selected={{
                color: 'components.tab.active',
                borderBottomColor: 'components.tab.active',
                opacity: 1,
              }}
              opacity={0.4}
            >
              <Box alignItems='center' display='inline-flex'>
                Associate Devices
              </Box>
            </Tab>
          </TabList>
          <TabPanels>
            <TabPanel mt='5px' px='0'>
              {shouldShowNoCameraAuthenticationAlert && (
                <NoCameraAuthenticationAlert
                  shouldRequireAuthentication={shouldRequireAuthentication}
                />
              )}
              <Box fontSize='16px' mb='3'>
                Enter Device Info to connect to a Device
              </Box>
              {type === DeviceType.Alarm && (
                <EditAlarmForm deviceId={id} onClose={onClose} />
              )}
              {type === DeviceType.Camera && (
                <EditCameraForm
                  deviceId={id}
                  onClose={onClose}
                  onRequiresAuthenticationChange={
                    handleRequiresAuthenticationSwitch
                  }
                  shouldRequireAuthentication={shouldRequireAuthentication}
                />
              )}
              {type === DeviceType.Door && (
                <EditDoorForm deviceId={id} onClose={onClose} />
              )}
            </TabPanel>
            <TabPanel mt='5px' px='0'>
              {/* Add new Associate UI */}
              <AssociateDevices deviceData={deviceData} onClose={onClose} />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </ModalContent>
    </Modal>
  )
}
